(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hominess-lineas"] && !Shopify.designMode) return;
  try {
    
  function hominessMontarVitrina(vitrina) {
    if (vitrina.dataset.montada === 'si') return;
    vitrina.dataset.montada = 'si';

    var tonos  = vitrina.querySelectorAll('.hom-lineas__tono');
    var items  = vitrina.querySelectorAll('.hom-lineas__item');
    var puntos = vitrina.querySelectorAll('.hom-lineas__punto');
    var total  = Math.min(tonos.length, items.length);
    if (total < 2) return;

    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var espera = Number(vitrina.dataset.intervalo) || 5000;
    var actual = 0;
    var reloj  = null;

    function mostrar(i) {
      actual = (i + total) % total;
      for (var k = 0; k < total; k++) {
        var on = k === actual ? 'si' : 'no';
        tonos[k].dataset.activo = on;
        items[k].dataset.activo = on;
        if (puntos[k]) puntos[k].setAttribute('aria-current', String(k === actual));
      }
    }
    function arrancar() {
      if (quieto || reloj) return;
      reloj = setInterval(function () { mostrar(actual + 1); }, espera);
    }
    function parar() { clearInterval(reloj); reloj = null; }

    puntos.forEach(function (b, i) {
      b.addEventListener('click', function () { parar(); mostrar(i); });
    });

    /* Se detiene mientras alguien está mirando o navegando con teclado. */
    vitrina.addEventListener('mouseenter', parar);
    vitrina.addEventListener('mouseleave', arrancar);
    vitrina.addEventListener('focusin', parar);
    vitrina.addEventListener('focusout', arrancar);

    /* Y también cuando la pestaña no está a la vista: ciclar en segundo plano
       solo gasta batería. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { parar(); } else { arrancar(); }
    });

    arrancar();
  }

  document.querySelectorAll('[data-vitrina]').forEach(hominessMontarVitrina);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-vitrina]').forEach(hominessMontarVitrina);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hominess-portada-catalogo"] && !Shopify.designMode) return;
  try {
    
  /* Travertino: ruido de valor suavizado en bandas horizontales. La veta sale de
     estirar el ruido en X. La semilla es fija, así que redimensionar no la cambia. */
  function hominessPintarPiedra(lienzo) {
    var caja = lienzo.getBoundingClientRect();
    if (!caja.width || !caja.height) return;

    var w = Math.max(1, Math.round(caja.width / 3));
    var h = Math.max(1, Math.round(caja.height / 3));
    lienzo.width = w;
    lienzo.height = h;

    var ctx = lienzo.getContext('2d');
    var img = ctx.createImageData(w, h);
    var d = img.data;
    var base = [220, 210, 196];
    var semilla = 20260908;

    function azar() {
      semilla = (semilla * 1103515245 + 12345) & 0x7fffffff;
      return semilla / 0x7fffffff;
    }

    var filas = [];
    for (var y = 0; y < h; y++) filas.push(azar());

    for (var y2 = 0; y2 < h; y2++) {
      var v = 0;
      for (var k = -6; k <= 6; k++) {
        v += filas[Math.min(h - 1, Math.max(0, y2 + k))];
      }
      v = v / 13;
      for (var x = 0; x < w; x++) {
        var veta = Math.sin((x / w) * 3.1 + v * 9) * 0.5 + 0.5;
        var f = (v * 0.72 + veta * 0.28 - 0.5) * 26;
        var p = (y2 * w + x) * 4;
        d[p] = base[0] + f;
        d[p + 1] = base[1] + f;
        d[p + 2] = base[2] + f * 0.85;
        d[p + 3] = 255;
      }
    }
    ctx.putImageData(img, 0, 0);
  }

  function hominessMontarPortada(raiz) {
    var lienzo = raiz.querySelector('.hom-port__lienzo');
    if (lienzo) {
      hominessPintarPiedra(lienzo);
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(function () { hominessPintarPiedra(lienzo); }, 180);
      });
    }

    var carrusel = raiz.querySelector('[data-carrusel]');
    if (!carrusel) return;

    var pista = carrusel.querySelector('[data-pista]');
    var mandos = carrusel.querySelectorAll('.hom-port__flecha');
    if (!pista || !mandos.length) return;

    function paso() {
      var tarjeta = pista.querySelector('.hom-port__fragancia');
      if (!tarjeta) return pista.clientWidth;
      var ancho = tarjeta.getBoundingClientRect().width + 2;
      /* Un salto = las tarjetas enteras que quepan, nunca menos de una. */
      return Math.max(ancho, Math.floor(pista.clientWidth / ancho) * ancho);
    }

    function refrescar() {
      var fin = pista.scrollWidth - pista.clientWidth - 2;
      mandos[0].disabled = pista.scrollLeft <= 2;
      mandos[1].disabled = pista.scrollLeft >= fin;
    }

    mandos.forEach(function (b) {
      b.addEventListener('click', function () {
        pista.scrollBy({ left: paso() * Number(b.dataset.dir), behavior: 'smooth' });
      });
    });

    pista.addEventListener('scroll', refrescar, { passive: true });
    window.addEventListener('resize', refrescar);
    refrescar();
  }

  document.querySelectorAll('.hom-port').forEach(hominessMontarPortada);

  /* El editor de temas reinyecta la sección sin recargar la página. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.hom-port').forEach(hominessMontarPortada);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
